export const FileClaimTestData = [{
    policyNumber: '5118J000008',
    dob: '01/01/1957',
    zip: '04049',
    lastName: 'Goring',
    user: 'VICT_GORI_7BB1_ST'
}];
